import Boundary from './Boundary.js';
import Drawable from './Drawable.js';
import { c } from '../setup.js';

export default class TextSource extends Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            text: this.text,
            position: this.position,
            _canInteract: this._canInteract,
        };
    }

    static deserialize(data) {
        return new TextSource({
            text: data.text,
            position: data.position,
        });
    }

    constructor({ text, position, OSM, GUI }) {
        super();
        this.text = text;
        this.position = position;
        this.width = Boundary.width;
        this.height = Boundary.height;
        this.xModifier = 0;
        this.yModifier = 0;
        this.OSM = OSM;
        this.GUI = GUI;
        this._canInteract = true;
        this.interactionPriority = 9;
    }

    canInteract() {
        return (this._canInteract = true);
    }

    endInteraction() {}

    draw() {
        c.fillStyle = 'rgba(0, 255, 0, 1)';
        // c.fillRect(this.position.x + this.xModifier, this.position.y + this.yModifier, this.width, this.height)
    }
}
